import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Lock } from "lucide-react"
import { Button } from "@/components/ui/button"
import { ADDON_LABELS, addonForFeature, minPlanFor } from "@/config/entitlements"

export function UpgradePrompt({ feature, title, description }) {
  const { t } = useTranslation()
  const addonId = addonForFeature(feature)
  const min = minPlanFor(feature)
  const isAddon = Boolean(addonId)
  const addonLabel = addonId ? (ADDON_LABELS[addonId] || addonId) : ""
  const heading =
    title ||
    (isAddon
      ? t("app.upgrade.addonTitle", { defaultValue: "Funcție disponibilă ca add-on" })
      : t("app.upgrade.planTitle", { defaultValue: "Funcție indisponibilă în planul curent" }))
  const body =
    description ||
    (isAddon
      ? t("app.upgrade.addonDescription", {
          addon: addonLabel,
          defaultValue: `Activează add-onul ${addonLabel} din Setări → Abonament (necesită plan Clinic).`,
        })
      : t("app.upgrade.planDescription", {
          plan: min.charAt(0).toUpperCase() + min.slice(1),
          defaultValue: `Disponibilă de la planul ${min.charAt(0).toUpperCase() + min.slice(1)}.`,
        }))

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-6 text-center">
      <div className="rounded-2xl border border-border bg-card p-10 max-w-md">
        <Lock strokeWidth={1.5} className="h-10 w-10 mx-auto text-muted-foreground mb-4" />
        <h2 className="font-display text-xl tracking-tight font-medium">{heading}</h2>
        <p className="text-sm text-muted-foreground mt-2">{body}</p>
        <Link
          to={isAddon ? "/app/integrations" : "/app/settings?tab=billing"}
          className="mt-6 inline-block"
        >
          <Button className="rounded-full">
            {isAddon
              ? t("app.upgrade.addonCta", { defaultValue: "Gestionează add-on-uri" })
              : t("app.upgrade.planCta", { defaultValue: "Vezi planuri și upgrade" })}
          </Button>
        </Link>
        <Link to="/pricing" className="mt-3 block text-xs text-muted-foreground hover:text-foreground">
          {t("app.upgrade.comparePlans", { defaultValue: "Compară toate planurile" })}
        </Link>
      </div>
    </div>
  )
}
